<template>
  <div class="about">
    <div class="title">关于灵佑引擎</div>
    <div class="content">
      灵佑引擎是杭州韵玟科技专为西方魔幻游戏打造的垂直开发平台，以"PC/Android/iOS三端数据无缝互通"和"可视化自由开发"为核心技术突破，搭载分布式架构引擎与低代码编辑器，让开发者无需跨平台适配即可
      实现"一次开发，全端覆盖"。平台内置西方魔幻题材专属素材库，提供各类西方魔幻游戏底板，支持从技能特效到剧情演出的深度定制，让经典西方魔幻文化通过现代技术焕发新生。
      <br />
      韵玟科技将持续迭代引擎的跨端性能与创作自由度，致力于传播游戏文化，达成我们与开发者之间的高效沟通，促进游戏全生态的运作，净化中国游戏生态环境，健康、稳健、可持续地发展，构筑"技术赋能经典，责任守护热爱"的新生态。
    </div>
  </div>
</template>

<style lang="scss" scoped>
.about {
  min-width: var(--pc-page-min-width);
  height: 870px;
  background-image: url('/images/about/bg.png');
  background-size: cover;
  padding-top: 60px;
}

.title {
  color: #ffffff;
  font-size: 28px;
  font-weight: 600;
  line-height: 51px;
  text-align: center;
  margin: 0 auto 32px;
  width: 293px;
  background-image: url('/images/titleBg.svg');
  background-size: cover;
}

.content {
  margin: 0 auto;
  width: 1200px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 24px;
  line-height: 40px;
}

@media screen and (orientation: portrait) {
  .about {
    min-width: 100vw;
    height: unset;
  }
  .content {
    width: 100vw;
  }
}
</style>
<script setup lang="ts">
</script>
